import _ from 'lodash';
import axios from 'axios';
import UPS from '@/extensions/shop/pointOfSale/store/api/ups'

export default {
    setToken(token, name = 'upstoken') {
        localStorage.setItem(name, token);
    },
    getToken(name = 'upstoken') {
        return localStorage.getItem(name) || '';
    },
    removeToken: (name = 'upstoken') =>
        new Promise((resolve, reject) => {
            localStorage.removeItem(name);
            setTimeout(() => resolve(), 150);
        }),
    refreshToken: (name = 'upstoken') =>

        new Promise((resolve, reject) => {
            /////////////////
            const token = localStorage.getItem("upstoken")

            if (token) {
                const endpoint = process.env.VUE_APP_API_ENDPOINT + "ups/refreshtoken";

                const payload = { refreshToken: JSON.parse(token).refresh_token };
                axios.post(endpoint, payload)
                    .then(({ data }) => {
                        console.log(data)
                        UPS.setToken(JSON.stringify(data));
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                        this.rendering.receipt = false;
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Receipt could not be rendered'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
            }
            /////////////////////////
        })
    ,
    createShipment(recipient) {
        return new Promise((resolve, reject) => {
            const endpoint = process.env.VUE_APP_API_ENDPOINT + "ups/createshipmentlabel";
            const token = JSON.parse(this.getToken()).access_token;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    transId: 'string',
                    transactionSrc: 'testing',
                    Authorization: `Bearer ${token}`
                }
            };

            axios.post(endpoint, JSON.stringify(recipient), config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.error(error)
                    this.rendering.receipt = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Receipt could not be rendered'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        });
    },
    requestRatings(recipient) {
        return new Promise((resolve, reject) => {
            const endpoint = process.env.VUE_APP_API_ENDPOINT + "ups/requestratings";
            const token = JSON.parse(this.getToken()).access_token;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    transId: 'string',
                    transactionSrc: 'testing',
                    Authorization: `Bearer ${token}`
                }
            };

            axios.post(endpoint, JSON.stringify(recipient), config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.error(error)
                    this.rendering.receipt = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Receipt could not be rendered'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        });
    },
    createReturnLabel(body) {
        return new Promise((resolve, reject) => {
            const endpoint = process.env.VUE_APP_API_ENDPOINT + "ups/createreturnlabel";
            const token = JSON.parse(this.getToken()).access_token;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    transId: 'string',
                    transactionSrc: 'testing',
                    Authorization: `Bearer ${token}`
                }
            };

            axios.post(endpoint, JSON.stringify(body), config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.error(error)
                    this.rendering.receipt = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Receipt could not be rendered'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        });
    },
};
